/**
 * Builds the og:image URL for non-stock top-level pages (Market
 * Intelligence, Short Interest, Options, etc.). Stocks have their
 * own helper in stock-og.ts because they pass ticker + sid to draw
 * the company logo and ticker pill — generic pages just render the
 * title on the shared 1200×630 card.
 */
import { OG_ENDPOINT } from "./stock-og";

export interface PageOgImage {
    ogImageUrl: string;
    cardTitle: string;
}

export function buildPageOgImage(title: string): PageOgImage {
    const params = new URLSearchParams({
        title,
        // Eyebrow on the card reads "ORTEX <PAGE NAME>" so the brand
        // and section are both legible at a glance — see api/og.tsx.
        label: `ORTEX ${title}`,
    });
    return { ogImageUrl: `${OG_ENDPOINT}?${params.toString()}`, cardTitle: title };
}
